/* global axios */
import ApiClient from './ApiClient';

class TalkviaCalendarEventsAPI extends ApiClient {
  constructor() {
    super('talkvia_calendar_events', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  create(data) {
    return axios.post(this.url, { talkvia_calendar_event: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { talkvia_calendar_event: data });
  }

  sync(id) {
    return axios.post(`${this.url}/${id}/sync`);
  }
}

export default new TalkviaCalendarEventsAPI();
